// controllers/phantom_element_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  // Default config (tweak here)
  fadeDistance = 60; // pixels: how close before fading starts
  exponent = 1.2; // >1 = steeper fade curve, 1 = linear
  transitionMs = 100; // ms: smoothness of opacity change

  connect() {
    this._onMouseMove = this._onMouseMove.bind(this);
    this._onScrollOrResize = this._onScrollOrResize.bind(this);
    this._mouse = { x: -99999, y: -99999 };
    this._ticking = false;

    document.addEventListener("mousemove", this._onMouseMove, {
      passive: true,
    });
    window.addEventListener("scroll", this._onScrollOrResize, {
      passive: true,
    });
    window.addEventListener("resize", this._onScrollOrResize, {
      passive: true,
    });

    // transition setup
    this.element.style.willChange = "opacity";
    if (!this.element.style.transition) {
      this.element.style.transition = `opacity ${this.transitionMs}ms linear`;
    }

    this._rafUpdate(); // initialize
  }

  disconnect() {
    document.removeEventListener("mousemove", this._onMouseMove);
    window.removeEventListener("scroll", this._onScrollOrResize);
    window.removeEventListener("resize", this._onScrollOrResize);
    if (this.element.style.pointerEvents === "none") {
      this.element.style.pointerEvents = "";
    }
  }

  _onMouseMove(e) {
    this._mouse.x = e.clientX;
    this._mouse.y = e.clientY;
    this._queueUpdate();
  }

  _onScrollOrResize() {
    this._queueUpdate();
  }

  _queueUpdate() {
    if (this._ticking) return;
    this._ticking = true;
    requestAnimationFrame(() => this._rafUpdate());
  }

  _rafUpdate() {
    const { x, y } = this._mouse;
    const r = this.element.getBoundingClientRect();

    // distance from cursor to rect (0 if inside)
    const dx = Math.max(r.left - x, 0, x - r.right);
    const dy = Math.max(r.top - y, 0, y - r.bottom);
    const dist = Math.hypot(dx, dy);

    const inside = x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;

    const maxD = Math.max(1, this.fadeDistance);
    const t = inside ? 0 : Math.min(dist / maxD, 1);
    const opacity = inside ? 0 : Math.pow(t, this.exponent);

    this.element.style.opacity = String(opacity);
    this.element.style.pointerEvents = inside ? "none" : "auto";

    this._ticking = false;
  }
}
